.button {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: var(--spacing-xxs);
    border: 1px solid transparent;
    border-radius: 32px;
    box-sizing: border-box;
    background-color: transparent;
    color: var(--colorTextPrimary);
    cursor: pointer;
    outline: none;
}

.button[data-hovered],
.button[data-pressed] {
    opacity: 0.7;
}

.button[data-focus-visible] {
    border-color: var(--colorBorderAccent);
}

.photo {
    display: inline-flex;
    align-items: center;
}

.chevron {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 150ms ease;
}

.button[aria-expanded='true'] .chevron {
    transform: rotate(180deg);
}
